<template>
  <div
    v-loading="loading"
    element-loading-text="加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>修改预付次数</span>
        <el-button style="float: right; padding: 3px 0" type="text" @click="back">返回</el-button>
      </div>
      <el-form label-position="right" label-width="110px" class="form">
        <el-form-item label="微信名称" class="box">
          <el-input v-model="userData.nickName" disabled></el-input>
        </el-form-item>
        <el-form-item label="姓名" class="box">
          <el-input v-model="userData.userName" disabled></el-input>
        </el-form-item>
        <el-form-item label="手机号" class="box">
          <el-input v-model="userData.mobile" disabled></el-input>
        </el-form-item>
        <el-form-item label="地址" class="box">
          <el-input v-model="userData.addr" disabled></el-input>
        </el-form-item>
        <!-- payNum 训练次数 xlNum诊疗次数 -->
        <el-form-item label="训练预付次数" class="box">
          <el-input v-model="userData.payNum" type="number"></el-input>
        </el-form-item>
        <el-form-item label="诊疗预付次数" class="box">
          <el-input v-model="userData.xlNum" type="number"></el-input>
        </el-form-item>
      </el-form>
      <div class="btn-box">
        <el-button class="saveBtn" @click="history" type="primary">查看积分流水</el-button>
        <el-button class="saveBtn" @click="commit" type="primary">保存</el-button>
        <el-button class="saveBtn" @click="back" type="primary">返回</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import ToolBar from "@/components/ToolBar.vue";
import HelpHint from "@/components/HelpHint.vue";
export default {
  data() {
    return {
      userData: {},
      loading: false,
      userId: this.$route.query.id
    };
  },
  mounted() {
    this.getUser();
  },
  methods: {
    commit() {
      var that = this;
      let id = this.$route.query.id;
      if (that.userData.payNum || that.userData.xlNum) {
        that
          .$confirm("请确认修改预付次数？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            center: true
          })
          .then(() => {
            that.$axios
              .post(this.baseUrl + "/updatePayNum", {
              // .post("/gymTest/updatePayNum", {
                xlNum: Number(that.userData.xlNum),
                payNum: Number(that.userData.payNum),
                userId: that.userId
              })
              .then(res => {
                console.log(res);
                if (res.data.code == 0) {
                  that.$notify({
                    title: "提交成功",
                    message: "已成功修改预付次数！",
                    type: "success"
                  });
                  this.getUser();
                } else {
                  that.$notify.error({
                    title: "保存失败",
                    message: res.data.message
                  });
                }
              })
              .catch(error => {
                console.log(error);
              });
          });
      } else {
        that.$notify.error({
          title: "保存失败",
          message: "请填写预付次数！"
        });
      }
    },
    back() {
      this.$router.go(-1);
    },
    //获取用户详情
    getUser() {
      var that = this;
      that.$axios
        .get(that.baseUrl + "/queryWxUser", {
        // .get("/gymTest/queryWxUser", {
          params: {
            userId: that.userId
          }
        })
        .then(res => {
          that.userData = res.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    history() {
      this.$router.push('/user_history?userName='+ this.userData.userName)
    }
  },
  components: {
    ToolBar,
    HelpHint
  }
};
</script>
<style scoped>
.form {
  overflow: hidden;
}
.box {
  width: 48%;
  float: left;
}
.wd50 {
  width: 47%;
}
.wd100 {
  width: 100%;
}
.mr {
  margin-right: 6%;
}
.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}

.box-card {
  width: 100%;
}
.btn-box {
  text-align: center;
  margin: 20px auto;
}
</style>
